export default "__VITE_ASSET__SasenY1Q__"